import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Button, ButtonBase, IconButton, makeStyles, Tooltip,
} from '@material-ui/core';

import PortalModal from './PortalModal';

const useStyles = makeStyles(theme => ({
    buttonIcon: {
        marginRight: theme.spacing(1),
    },
    activeIcon: {
        color: theme.youwell.colors.secondary,
    },
}));


const ModalAction = ({
    disabled, modalHeading, buttonText, Icon, buttonChildren, children, wideModal, action, buttonProps, active, className, Modal, ModalProps, tooltip,
}) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const openModal = () => {
        setOpen(true);
    };

    const closeModal = () => {
        setOpen(false);
    };

    const renderAction = () => {
        if (action != null) {
            return action(openModal);
        } if (Icon !== null) {
            return (
                <IconButton onClick={openModal} className={className}>
                    <Icon fontSize="inherit" color="inherit" className={active ? classes.activeIcon : null} />
                </IconButton>
            );
        } if (buttonChildren !== null) {
            return (
                <ButtonBase className={classes.button} onClick={openModal} {...buttonProps}>
                    {buttonChildren}
                </ButtonBase>
            );
        }
        return (
            <Button onClick={openModal} variant="outlined" disabled={disabled} color="primary" className={className} {...buttonProps}>
                {buttonText || modalHeading}
            </Button>
        );
    };

    const renderActionWithTooltip = () => (tooltip ? (
        <Tooltip title={tooltip}>
            {renderAction()}
        </Tooltip>
    )
        : renderAction()
    );

    return (
        <>
            <PortalModal
                open={open}
                onClose={closeModal}
                heading={modalHeading}
                wide={wideModal}
            >
                {children}
                {open && Modal && (
                    <Modal onClose={closeModal} {...ModalProps} />
                )}
            </PortalModal>

            {renderActionWithTooltip()}
        </>
    );
};

ModalAction.propTypes = {
    modalHeading: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.element,
    ]),
    buttonText: PropTypes.string,
    Icon: PropTypes.object,
    action: PropTypes.func,
    disabled: PropTypes.bool,
    wideModal: PropTypes.bool,
    buttonProps: PropTypes.object,
    active: PropTypes.bool,
    className: PropTypes.string,
    Modal: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
    ]),
    ModalProps: PropTypes.object,
    tooltip: PropTypes.string,
    buttonChildren: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.element,
        PropTypes.string,
    ]),
};

ModalAction.defaultProps = {
    disabled: false,
    buttonText: null,
    Icon: null,
    action: null,
    wideModal: false,
    buttonProps: null,
    active: false,
    className: null,
    children: null,
    Modal: null,
    ModalProps: null,
    tooltip: null,
    buttonChildren: null,
};

export default ModalAction;
